import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import TypologiesContainer from "../../../containers/admin/typologies/TypologiesContainer";
import MenuAdmin from "../Menu";

class Typologies extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("imports");
    this.props.setMenuLeftContent(MenuAdmin);
    this.props.setMenuLeftIndex("typologies");
  }
  render() {
    return (
      <Fragment>
        <TypologiesContainer {...this.props} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Typologies);



// WEBPACK FOOTER //
// src/pages/imports/imports/Typologies.js